export default __webpack_public_path__ + "static/media/Reykjavik_Daytours.4913c90f.webp";